module.exports = __webpack_public_path__ + "media/images/icon-benefits-247-c1d1219552af42a4db37dee91b9f2418.png";